import { render, staticRenderFns } from "./IQuestionWhite.vue?vue&type=template&id=66848fd2&"
import script from "./IQuestionWhite.vue?vue&type=script&lang=ts&"
export * from "./IQuestionWhite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports